module.exports = __webpack_public_path__ + "static/media/Icons_calling-exotel.92b28ca3.svg";